module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Foreword by Gene Wolfe")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/lastplane"
    }
  }, [_vm._v("Last Plane to Heaven: A Love Story")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/angeli"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Angels i")]), _vm._v(" The Houses of the Favored")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1#pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCIENCE AND OTHER FICTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Starship Mechanic")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permanent Fatal Errors")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Hello,” Said the Gun")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Speed of Time")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("West to East")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Women Who Ate Stone Squid")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking for Truth in a Wild Blue Yonder")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Angels ii")]), _vm._v(" Scent of the Green Cathedral")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEAM, PUNKS, AND FAIRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spendthrift")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jefferson’s West")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Are Forgotten Until They Come Again")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Woman Who Shattered the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blade of His Plow")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grindstone")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Temptation of Eustace Prudence McAllen")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Which Rises Ever Upward")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Angels iii")]), _vm._v(" A Feast of Angels")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHANTASIES OF STYLE AND PLACE")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Promises: A Tale of the City Imperishable")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Testaments")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Critical Examination of Stigmata’s Print "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Taking the Rats to Riga")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Countries of Her Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unchambered Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Angels iv")]), _vm._v(" Novus Ordo Angelorum")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESCENT INTO DARKNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tentacled Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Such Bright and Risen Madness in Our Names")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Fingers Like Whips, Her Eyes Like Razors")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Urban’s Book of Dayes")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Angels v")]), _vm._v(" Going Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTC"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE END")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cancer Catechism")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tor Books by Jay Lake")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightacknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Copyright Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0